import { isEmpty } from '@sgme/fp';
import { ButtonsGroup } from 'components/shared/ButtonsGroup/ButtonsGroup';
import type { SelectedProductVariation } from 'models/productsReferential';
import type { FC } from 'react';
import { useSelector } from 'react-redux';
import { getAvailablePayoffTypes } from 'state/selectors';
import type { AppState } from 'state/state.model';
import type { WorkspaceWithProductSelector } from 'state/workspaces/workspaces/workspaces.model';

interface PayoffTypeSelectorProps {
  workspace: WorkspaceWithProductSelector;
  selectedProductVariation: Partial<SelectedProductVariation>;
  onPayoffTypeSelected(payoffType: string): void;
}
export const PayoffTypeSelector: FC<PayoffTypeSelectorProps> = ({
  selectedProductVariation,
  workspace,
  onPayoffTypeSelected,
}) => {
  const availablePayoffTypes = useSelector((state: AppState) =>
    getAvailablePayoffTypes(state, workspace, selectedProductVariation),
  );

  if (isEmpty(availablePayoffTypes)) {
    return null;
  }

  return (
    <div className="d-flex flex-column mt-2">
      <label className="form-label mb-1" htmlFor="payoff-type-selector">
        Default payoff type
      </label>
      <ButtonsGroup
        className="btn-group-lg"
        items={availablePayoffTypes}
        selectedItems={selectedProductVariation?.payoffType ?? null}
        translationPrefix="form.PayoffType"
        onSelect={items => onPayoffTypeSelected(items[0])}
        e2e="payoff-type-selector"
        isRadio
      />
    </div>
  );
};
